import '../Advertiser.styles/oswald-font.css';
import '../Advertiser.styles/styles.scss';


import { LogManager } from 'aurelia-framework';
import { ConsoleAppender } from 'aurelia-logging-console';
import { HttpClient } from 'aurelia-fetch-client';

var async = require('async');
var config = require('../config.js');

LogManager.addAppender(new ConsoleAppender());
LogManager.setLevel( config.frameworkLogLevel );

// comment out if you don't want a Promise polyfill (remove also from webpack.common.js)
import * as Bluebird from 'bluebird';
Bluebird.config({
    warnings: false
});

export async function configure(aurelia) {
    aurelia.use
        .standardConfiguration()
        .plugin(PLATFORM.moduleName('aurelia-validation'))
        .plugin(PLATFORM.moduleName('aurelia-dialog'), config => {
            config.useDefaults();
            config.settings.lock = false;
            config.settings.centerHorizontalOnly = false;
            config.settings.startingZIndex = 1005;
        })
        .globalResources([
            PLATFORM.moduleName('Advertiser.SharedPortal/resources/dollarCents'),
            PLATFORM.moduleName('Advertiser.SharedPortal/resources/maxRange'),
            PLATFORM.moduleName('Advertiser.SharedPortal/resources/numberFormat'),
            PLATFORM.moduleName('Advertiser.SharedPortal/resources/submenu'),
            PLATFORM.moduleName('Advertiser.SharedPortal/resources/submenuActive')
        ]);
        //.developmentLogging();

    // Uncomment the line below to enable animation.
    // aurelia.use.plugin('aurelia-animator-css');
    // if the css animator is enabled, add swap-order="after" to all router-view elements

    // Anyone wanting to use HTMLImports to load views, will need to install the following plugin.
    // aurelia.use.plugin('aurelia-html-import-template-loader')

    await aurelia.start();
    aurelia.setRoot(PLATFORM.moduleName('app'));

    // if you would like your website to work offline (Service Worker), 
    // install and enable the @easy-webpack/config-offline package in webpack.config.js and uncomment the following code:
    /*
    const offline = await System.import('offline-plugin/runtime');
    offline.install();
    */

   if (config.toggleFeatureGlobalExceptionHandler) {
      window.onerror = function (msg, url, lineNo, columnNo, error) {
         let that = this;

         async.series( [
            function ( cb ) {
               var string = msg.toLowerCase();
               var substring = "script error";

               if (string.indexOf(substring) > -1) {
                  alert('Script Error: See Browser Console for Detail');
               } else {
                  var message = [
                     'Error Message: ' + msg,
                     'URL: ' + url,
                     'Line: ' + lineNo,
                     'Column: ' + columnNo
                  ].join(' - ');

                  var httpClient = new HttpClient();
                  var url = config.webLoggerUrl;
                  var username = window.localStorage.getItem('userName');

                  var jsonData = {
                     "username" : username? username : 'unknown',
                     "http_code" : 500,
                     "message": message,
                     "component": url,
                     "subcomponent": 'User Portal',
                     "stack_trace": 'line: ' + lineNo + ' column: ' + columnNo,
                     "severity": 'error',
                     "build_version": ''
                  };
                  
                  let allHeaders = {
                     headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                     }
                  };

                  httpClient.configure( httpConfig => {
                     httpConfig
                        .withBaseUrl('/')
                        .withDefaults({
                              headers: allHeaders.headers
                        });
                  });
                  
                  httpClient.fetch( url, {
                     mode: 'cors',
                     method: 'POST',
                     body: JSON.stringify(jsonData)
                  })
                  .then( response => { return cb(); })
               }
            },
            function( cb ) {
               if (confirm('An error occurred, would you like to try and reload the page?\n\n' + msg + '\n')) {
                  window.location.reload(true);
               }
               return cb();
            }
         ]);
      };
   }
}
